angular.module('components.caOrderRowsEdit', [])
    .component('caOrderRowsEdit', {
        templateUrl: 'main/order/orderdelivery/components/orderrowsedit.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderChangeCount: '=',
            order: '=',
            disabled: '<',
            currentOrderArticle: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $rootScope, $translate, OrdersApiService, loadSpinnerService, ProductsApiService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.hasClaim = havePurchaseCostClaim();
    vm.hasQuantities = false;
    vm.hasDifferentVariantPrices = false;
    vm.stocks = [];
    vm.colorRelatedPurchaseCosts = [];
    vm.colorVariantRelatedPurchaseCosts = [];
    vm.defaultCurrency = {};

    //Private variables
    var rowsGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);
    var originalCellValue = '';
    var pricesGrid = {};
    var variantPricesGrid = {};
    
    //Methods
    vm.captureRowsGrid = captureRowsGrid;
    vm.capturePricesGrid = capturePricesGrid;
    vm.captureVariantPricesGrid = captureVariantPricesGrid;
    vm.handleNonexistingArticleVariants = handleNonexistingArticleVariants;
    vm.transferQuantityGridDataToOrder = transferQuantityGridDataToOrder;
    vm.transferPurchaseCostDataToOrder = transferPurchaseCostDataToOrder;
    vm.transferVariantPurchaseCostDataToOrder = transferVariantPurchaseCostDataToOrder;
    vm.recalculateGridTotals = recalculateGridTotals;
    vm.recalculateVariantGridTotals = recalculateVariantGridTotals;
    vm.hasGridQuantities = hasGridQuantities;
    vm.hasGridDifferentVariantPrices = hasGridDifferentVariantPrices;
    vm.beginEditingOrderRow = beginEditingOrderRow;
    vm.orderRowEditEnded = orderRowEditEnded;
    vm.hasRetrievedStocks = hasRetrievedStocks;
    vm.getStockQuantitiesForCurrentArticle = getStockQuantitiesForCurrentArticle;
    vm.getCurrencyCodeString = getCurrencyCodeString;
    vm.getTotalRowSum = getTotalRowSum;
    vm.isAllowedToAddProduct = isAllowedToAddProduct();
    vm.isSingleVariantArticle = isSingleVariantArticle;

    function isAllowedToAddProduct(){
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        return !hasOrderId || vm.order.systemStatus === "created"
    }


    function onInit() {
        $scope.$watch(function () { return vm.orderChangeCount; }, function () {
            recalculateGridTotals();
            recalculateVariantGridTotals();

            vm.hasQuantities = hasGridQuantities();
            if (vm.currentOrderArticle) {
                if (vm.currentOrderArticle.hasDifferentVariantPrices) {
                    constructVariantPurchaseCostData();
                } else {
                    constructPurchaseCostData();
                }
            }
            
        });
        $scope.$watch(function () {
            return (vm.currentOrderArticle === undefined || vm.currentOrderArticle.article === undefined) ?
                undefined :
                vm.currentOrderArticle.article.id;
        }, function () {
            if (vm.currentOrderArticle !== undefined && vm.currentOrderArticle.article !== undefined) {
                resetCurrentOrderArticlePresentation();
            }
        });

        ProductsApiService.getDefaultCurrency().then(function(response) {
            vm.defaultCurrency = response;
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    
    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.update){
            return false
        }

        return true
    }

    function getCurrencyCodeString() {
        if (!vm.order || !vm.order.currency) { return ''; }
        if (vm.order.orderType.orderSystemType === 'return') { return ''; }
        return ' (' + vm.order.currency.code + ')';
    }

    function resetCurrentOrderArticlePresentation() {
        initializeGridColumns();
        loadGridData();
        constructSalesPriceData();
        vm.hasQuantities = hasGridQuantities();
        vm.currentOrderArticle.hasDifferentVariantPrices = hasGridDifferentVariantPrices();


        if (vm.currentOrderArticle.hasDifferentVariantPrices) {
            constructVariantPurchaseCostData();
        } else {
            constructPurchaseCostData();
        }
    }

    function beginEditingOrderRow(s, e) {
        vm.handleNonexistingArticleVariants(s, e);

        if (hasRetrievedStocks(vm.currentOrderArticle.article)) {
            var rowNumber = rowsGrid.selection.row;
            var columnNumber = rowsGrid.selection.col;

            var columnHeader = rowsGrid.columns[columnNumber].binding;

            originalCellValue = angular.copy(rowData[rowNumber][columnHeader]);

            rowData[rowNumber][columnHeader] = rowData[rowNumber][columnHeader].split('(')[0].trim();
            rowCollection.refresh();
        }
    }

    function handleNonexistingArticleVariants(sender, event) {
        var row = sender.rows[event.row];
        var col = sender.columns[event.col];
        var item = row.dataItem;
        var colBinding = col.binding;
        var cellValue = item[colBinding];

        if (cellValue === undefined) {
            event.cancel();
        }
    }

    function hasRetrievedStocks(article) {
        return vm.stocks.length > 0 &&
            vm.stocks[article.id] &&
            vm.stocks[article.id].variantStocks &&
            vm.stocks[article.id].variantStocks.length > 0;
    }

    function orderRowEditEnded(sender, event) {
        if (hasRetrievedStocks(vm.currentOrderArticle.article)) {
            var rowNumber = rowsGrid.selection.row;
            var columnNumber = rowsGrid.selection.col;

            var columnHeader = rowsGrid.columns[columnNumber].binding;

            // Reinserting the parenthesis value, but only if we have a retrieved article variant stock
            var valueSplit = originalCellValue.split('(');
            var stockStr = '';
            if (valueSplit.length > 1) {
                stockStr = ' (' + valueSplit[1];
            }
            rowData[rowNumber][columnHeader] += stockStr;
            rowCollection.refresh();
        }

        vm.transferQuantityGridDataToOrder();
        vm.recalculateGridTotals();
    }

    function getStockQuantitiesForCurrentArticle() {
        loadSpinnerService.start('mainSpinner');
        var articleId = vm.currentOrderArticle.article.id;
        var locationId = vm.order.fromLocation.id;

        // /article/{articleId}/location/{locationId}/stock
        OrdersApiService.getStockForArticle(articleId, locationId).then(function(response) {
            vm.stocks[articleId] = { variantStocks: response.stock };
            resetCurrentOrderArticlePresentation();
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function captureRowsGrid(grid) {
        rowsGrid = grid;
        rowsGrid.initialize({ 
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            frozenColumns: 2,
            itemsSource: rowCollection    
        });

        setupGrid();

        if (vm.order.id !== undefined) {
            loadGridData();
        }
    }

    function setupGrid() {
        rowData.length = 0;
        rowsGrid.finishEditing(true);
        rowsGrid.columns.clear();
        rowsGrid.invalidate();
        rowCollection.refresh();
        initializeGridColumns();
    }

    function initializeGridColumns() {
        if (rowsGrid.columns) {
            rowsGrid.columns.length = 0;

            // Add first row header column
            var rowHeader = new wijmo.grid.Column();
            rowHeader.binding = "variantDetails1Name";
            rowHeader.header = " ";
            rowHeader.allowSorting = false;
            rowHeader.allowResizing = true;
            rowHeader.width = 200;
            rowHeader.minWidth = 100;
            rowHeader.isReadOnly = true;
            rowsGrid.columns.push(rowHeader);

            var columns = getDataColumns();

            if (columns.length > 1) {
                var rowTotalCol = new wijmo.grid.Column();
                rowTotalCol.header = $translate.instant('customerorder.totalquantity');
                rowTotalCol.allowSorting = false;
                rowTotalCol.allowResizing = true;
                rowTotalCol.width = 100;
                rowTotalCol.minWidth = 100;
                rowTotalCol.isReadOnly = true;
                rowTotalCol.binding = "rowTotal";
                rowTotalCol.align = "right";
                rowsGrid.columns.push(rowTotalCol);
            }

            // Add dynamic columns
            _.forEach(columns, function (variantDetail) {
                var c = new wijmo.grid.Column();
                c.binding = variantDetail.variantDetailName;
                c.header = variantDetail.variantDetailName;
                c.width = "*";
                c.minWidth = 100;
                c.allowSorting = false;
                c.allowResizing = true;
                c.inputType = 'tel';
                c.dataType = "Number";
                c.isReadOnly = false;
                c.align = "right";
                rowsGrid.columns.push(c);
            });
        }
    }

    function getDataColumns() {
        var columns = [];

        var articleVariants = [];

        if (vm.currentOrderArticle !== undefined) {
            _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
                articleVariants.push(orderRow.articleVariant);
            });
        }

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(articleVariants, function (variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function (newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function loadGridData() {
        rowData.length = 0;
        var variantRows = _.groupBy(vm.currentOrderArticle.orderRows, function (orderRow) {
            return orderRow.articleVariant.variantDetail1.variantDetailName;
        });

        _.forEach(variantRows, function (variantRowValues) {
            var r = {};
            var sum = 0;

            if (!variantRowValues.hasBeenModifiedSinceLoad) { variantRowValues.hasBeenModifiedSinceLoad = true; }

            _.forEach(variantRowValues, function (variantRowValue) {
                r.variantDetails1Name = variantRowValue.articleVariant.variantDetail1.variantDetailName;
                var variantRowQuantity = variantRowValue['quantity'];
                var delQuantity = (variantRowValue.hasBeenModifiedSinceLoad) ?
                    variantRowQuantity :
                        (variantRowQuantity - Math.abs((variantRowValue.summarizedDeliveredQuantity !== undefined) ?
                            variantRowValue.summarizedDeliveredQuantity :
                            0));

                //Display stock in cell if already fetched from backend
                if (hasRetrievedStocks(vm.currentOrderArticle.article)) {
                    var articleStocks = vm.stocks[vm.currentOrderArticle.article.id];
                    var existingStock = articleStocks !== undefined && articleStocks.variantStocks.length > 0 ?
                        _.find(articleStocks.variantStocks, function(o) { return o.articleVariantId === variantRowValue.articleVariant.id; }) :
                        undefined;
                    var existingStockStr = existingStock !== undefined ? ' (' + existingStock.quantity + ')' : '';

                    r[variantRowValue.articleVariant.variantDetail2.variantDetailName] = delQuantity + existingStockStr;
                } else {
                    r[variantRowValue.articleVariant.variantDetail2.variantDetailName] = delQuantity;
                }

                r.variantExternalId = variantRowValue.articleVariant.externalId;
                r.systemStatus = variantRowValue.systemStatus 
                r.systemName = variantRowValue.statusName 

                sum += delQuantity;
            });
            r['rowTotal'] = sum;
            rowData.push(r);
        });
        rowCollection.refresh();
    }

    function capturePricesGrid(sender) {
        pricesGrid = sender;
        isAllowedToEditRow(pricesGrid)
        pricesGrid.itemsSource = vm.colorRelatedPurchaseCosts;

        pricesGrid.itemFormatter = function (panel, r, c, cell) {
            var style = cell.style;
            var regularCellType = wijmo.grid.CellType.Cell;

            var greyedColumnNumbers = [4, 5, 6, 11, 12, 13];

            if (_.find(greyedColumnNumbers, function (e) { return e === c; }) && panel.cellType === regularCellType) {
                style.color = '#000000';
                style.backgroundColor = '#eeeeee';
            }
        };

        vm.recalculateGridTotals();
        vm.transferPurchaseCostDataToOrder();
    }

    function captureVariantPricesGrid(sender) {
        variantPricesGrid = sender;
        isAllowedToEditRow(variantPricesGrid)
        variantPricesGrid.itemsSource = vm.colorVariantRelatedPurchaseCosts;

        variantPricesGrid.itemFormatter = function (panel, r, c, cell) {
            var style = cell.style;
            var regularCellType = wijmo.grid.CellType.Cell;
            var greyedColumnNumbers = [5, 10, 11, 12, 13];

            if (_.find(greyedColumnNumbers, function (e) { return e === c; }) && panel.cellType === regularCellType) {
                style.color = '#000000';
                style.backgroundColor = '#eeeeee';
            }
        };

        vm.recalculateVariantGridTotals();
        vm.transferVariantPurchaseCostDataToOrder();
    }

    function isAllowedToEditRow(variantPricesGrid){
        variantPricesGrid.beginningEdit.addHandler((s, e) => {
            let item = s.rows[e.row].dataItem;
			if (item.systemStatus === "delivered") { // prevent editing if status on row dose not allow
                e.cancel = true;      
            }
        })
    }

    function constructPurchaseCostData() {
        vm.colorRelatedPurchaseCosts = [];

        var grouped = _.groupBy(vm.currentOrderArticle.orderRows, function (row) {
            return row.articleVariant.variantDetail1.variantDetailName;
        });

        var keys = Object.keys(grouped);

        _.forEach(keys, function (key) {
            var representative = _.find(grouped[key], function (element) { return element.quantity > 0; });

            if (representative) {
                var item = {
                    color: key,
                    purchaseCost: representative.purchaseCost,
                    originalPurchasePrice: representative.originalPurchasePrice,
                    discountPercent: representative.discountPercent,
                    standardCostAddPercent: representative.standardCostAddPercent,
                    effectivePurchasePrice: representative.effectivePurchasePrice,
                    shippingCost: representative.shippingCost,
                    customsPercent: representative.customsPercent,
                    otherCosts: representative.otherCosts,
                    systemStatus: representative.systemStatus,
                    statusName: representative.statusName,
                    sumQuantity: 0,
                    rows: grouped[key]
                };

                _.forEach(item.rows, function (row) {
                    item.sumQuantity += parseInt(row.quantity);
                });

                vm.colorRelatedPurchaseCosts.push(item);
            }
        });

        pricesGrid.itemsSource = vm.colorRelatedPurchaseCosts;
        if (typeof pricesGrid.invalidate === 'function') { pricesGrid.invalidate(); }
        if (pricesGrid.collectionView && typeof pricesGrid.collectionView.refresh === 'function') { pricesGrid.collectionView.refresh(); }
    }

    function constructVariantPurchaseCostData() {
        vm.colorVariantRelatedPurchaseCosts = [];

        var rows = vm.currentOrderArticle.orderRows.filter(x => x.id !== 0)

        _.forEach(rows, function (row) {
            var item = {
                color: row.articleVariant.variantDetail1.variantDetailName,
                size: row.articleVariant.variantDetail2.variantDetailName,
                purchaseCost: row.purchaseCost,
                originalPurchasePrice: row.originalPurchasePrice,
                discountPercent: row.discountPercent,
                standardCostAddPercent: row.standardCostAddPercent,
                effectivePurchasePrice: row.effectivePurchasePrice,
                quantity: parseInt(row.quantity),
                shippingCost: row.shippingCost,
                customsPercent: row.customsPercent,
                otherCosts: row.otherCosts,
                systemStatus: row.systemStatus,
                statusName: row.statusName
            };
            vm.colorVariantRelatedPurchaseCosts.push(item);
        });

        variantPricesGrid.itemsSource = vm.colorVariantRelatedPurchaseCosts;
        if (typeof variantPricesGrid.invalidate === 'function') { variantPricesGrid.invalidate(); }
        if (variantPricesGrid.collectionView && typeof variantPricesGrid.collectionView.refresh === 'function') { variantPricesGrid.collectionView.refresh(); }
    }

    function constructSalesPriceData() {
        vm.colorVariantRelatedSalesPrices = [];

        var grouped = _.groupBy(vm.currentOrderArticle.orderRows, function (row) {
            return row.articleVariant.variantDetail1.variantDetailName;
        });

        var keys = Object.keys(grouped);

        _.forEach(keys, function (key) {
            var averageSalesPrice = (_.sumBy(grouped[key], function (element) { return element.salesPrice; })) / grouped[key].length;
            var averagePurchaseCost = (_.sumBy(grouped[key], function (element) { return element.purchaseCost; })) / grouped[key].length;

            var item = {
                color: key,
                averageSalesPrice: averageSalesPrice,
                averagePurchaseCost: averagePurchaseCost,
                rows: grouped[key]
            };

            vm.colorVariantRelatedSalesPrices.push(item);
        });
    }

    function transferQuantityGridDataToOrder() {
        var currentOrderArticle = _.find(vm.order.orderArticles, function (orderArticle) {
            return vm.currentOrderArticle.article.id === orderArticle.article.id;
        });

        _.forEach(currentOrderArticle.orderRows, function (orderRow) {
            var row = _.find(rowData, function (row) {
                return row['variantDetails1Name'] === orderRow.articleVariant.variantDetail1.variantDetailName;
            });
            if (row !== undefined) {
                var quantity = parseInt(row[orderRow.articleVariant.variantDetail2.variantDetailName]);
                if (quantity < 0) {
                    var quantityCustomized = parseInt(quantity.toString().replace("-",""));
                    row[orderRow.articleVariant.variantDetail2.variantDetailName] = quantityCustomized;
                    orderRow.quantity = quantityCustomized;
                } else {
                    orderRow.quantity = quantity;
                }
            }
        });

        vm.orderChangeCount += 1;
    }

    function transferPurchaseCostDataToOrder() {
        _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
            var rows = _.filter(vm.colorRelatedPurchaseCosts, function (row) {
                return row['color'] === orderRow.articleVariant.variantDetail1.variantDetailName;
            });
            if (rows !== undefined) {
                _.forEach(rows, function (row) {
                    orderRow.purchaseCost = parseFloat(row['purchaseCost']);
                    orderRow.originalPurchasePrice = parseFloat(row['originalPurchasePrice']);
                    orderRow.discountPercent = parseFloat(row['discountPercent']);
                    orderRow.standardCostAddPercent = parseFloat(row['standardCostAddPercent']);
                    orderRow.effectivePurchasePrice = parseFloat(row['effectivePurchasePrice']);
                    orderRow.shippingCost = parseFloat(row['shippingCost']);
                    orderRow.customsPercent = parseFloat(row['customsPercent']);
                    orderRow.otherCosts = parseFloat(row['otherCosts']);
                });
            }
        });

        vm.orderChangeCount += 1;
    }

    function transferVariantPurchaseCostDataToOrder() {
        _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
            var rows = _.filter(vm.colorVariantRelatedPurchaseCosts, function (row) {
                return row['color'] === orderRow.articleVariant.variantDetail1.variantDetailName &&
                    row['size'] === orderRow.articleVariant.variantDetail2.variantDetailName;
            });
            if (rows !== undefined) {
                _.forEach(rows, function (row) {
                    orderRow.purchaseCost = parseFloat(row['purchaseCost']);
                    orderRow.originalPurchasePrice = parseFloat(row['originalPurchasePrice']);
                    orderRow.discountPercent = parseFloat(row['discountPercent']);
                    orderRow.standardCostAddPercent = parseFloat(row['standardCostAddPercent']);
                    orderRow.effectivePurchasePrice = parseFloat(row['effectivePurchasePrice']);
                    orderRow.shippingCost = parseFloat(row['shippingCost']);
                    orderRow.customsPercent = parseFloat(row['customsPercent']);
                    orderRow.otherCosts = parseFloat(row['otherCosts']);
                });
            }
        });

        vm.orderChangeCount += 1;
    }

    function hasGridQuantities() {
        var hasQuantities = false;

        if (vm.currentOrderArticle && vm.currentOrderArticle.orderRows) {
            _.forEach(vm.currentOrderArticle.orderRows, function (row) {
                if (row.quantity > 0) { hasQuantities = true; }
            });
        }

        return hasQuantities;
    }

    function hasGridDifferentVariantPrices() {
        if (vm.currentOrderArticle.orderRows.length === 0) {
            return false;
        }

        var firstRow = vm.currentOrderArticle.orderRows[0];

        var rows = vm.currentOrderArticle.orderRows.filter(x => x.id !== 0)

        var isAllEqual = _.every(rows, function(orderRow) {
            return orderRow.originalPurchasePrice === firstRow.originalPurchasePrice &&
                   orderRow.discountPercent === firstRow.discountPercent &&
                   orderRow.shippingCost === firstRow.shippingCost &&
                   orderRow.customsPercent === firstRow.customsPercent &&
                   orderRow.otherCosts === firstRow.otherCosts &&
                   orderRow.standardCostAddPercent === firstRow.standardCostAddPercent &&
                   orderRow.systemStatus === firstRow.systemStatus;
        });

        return !isAllEqual;
    }

    function recalculateGridTotals() {
        if (vm.currentOrderArticle === undefined) {
            return;
        }
        if (vm.colorRelatedPurchaseCosts && vm.colorRelatedPurchaseCosts.length > 0) {
            var variant2Details = [];
            var variant1Details = [];
            _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
                if (!_.find(variant2Details, function (vd) { return vd.id === orderRow.articleVariant.variantDetail2.id; })) {
                    variant2Details.push(orderRow.articleVariant.variantDetail2);
                }
            });

            _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
                if (!_.find(variant1Details, function (vd) { return vd.id === orderRow.articleVariant.variantDetail1.id; })) {
                    variant1Details.push(orderRow.articleVariant.variantDetail1);
                }
            });

            _.forEach(variant1Details, function (vd1) {
                var quantitySum = 0;
                var row = _.find(rowData, function (row) { return row.variantDetails1Name === vd1.variantDetailName; });
                _.forEach(variant2Details, function (vd2) {
                    var parsed = parseInt(row[vd2.variantDetailName]);
                    if (!_.isNaN(parsed)) {
                        quantitySum += parsed;
                    }
                });
                row['rowTotal'] = quantitySum;

                if (vm.colorRelatedPurchaseCosts && vm.colorRelatedPurchaseCosts.length > 0) {
                    var purchaseCostRow = _.find(vm.colorRelatedPurchaseCosts, function (currentRow) { return currentRow.color === vd1.variantDetailName; });
                    if (purchaseCostRow) {
                        purchaseCostRow.sumQuantity = quantitySum;

                        purchaseCostRow.effectivePurchasePrice = calculateEffectivePurchasePrice(purchaseCostRow.originalPurchasePrice, purchaseCostRow.discountPercent);
                        purchaseCostRow.purchaseCost = getTotalRowSum(purchaseCostRow);
                    }
                }
            });

            if (rowsGrid.invalidate) {
                rowsGrid.invalidate();
            }
            if (pricesGrid.invalidate) {
                pricesGrid.invalidate();
            }
        }
    }

    function calculateEffectivePurchasePrice(originalPurchasePrice, discountPercent) {
        var discountAmount = (originalPurchasePrice * discountPercent / 100);
        return originalPurchasePrice - discountAmount;
    }

    function getTotalRowSum(rowItem) {
        var pp = calculateEffectivePurchasePrice(rowItem.originalPurchasePrice, rowItem.discountPercent);
        var ppCurrencyConverted = pp * vm.order.currencyRate;
        var customsAmount = (ppCurrencyConverted + rowItem.shippingCost) * (rowItem.customsPercent / 100);
        var standardCostAddAmount = (ppCurrencyConverted + rowItem.shippingCost + customsAmount + rowItem.otherCosts) * (rowItem.standardCostAddPercent / 100);

        var result = ppCurrencyConverted + rowItem.shippingCost + customsAmount + rowItem.otherCosts + standardCostAddAmount;

        return result;
    }

    function isSingleVariantArticle(article) {
        if (article === undefined) { return }
        return !article.isVariant || article.articleVariants.length < 2;
    }

    function recalculateVariantGridTotals() {
        if (vm.currentOrderArticle === undefined) {
            return;
        }
        if (vm.colorVariantRelatedPurchaseCosts && vm.colorVariantRelatedPurchaseCosts.length > 0) {
            _.forEach(vm.currentOrderArticle.orderRows, function (orderRow) {
                var purchaseCostRow = _.find(vm.colorVariantRelatedPurchaseCosts, function (purchaseRow) {
                    return purchaseRow.color === orderRow.articleVariant.variantDetail1.variantDetailName &&
                        purchaseRow.size === orderRow.articleVariant.variantDetail2.variantDetailName;
                });

                if (purchaseCostRow) {
                    purchaseCostRow.quantity = purchaseCostRow.quantity;
                    purchaseCostRow.effectivePurchasePrice = calculateEffectivePurchasePrice(purchaseCostRow.originalPurchasePrice, purchaseCostRow.discountPercent);
                    purchaseCostRow.purchaseCost = getTotalRowSum(purchaseCostRow);

                    _.forEach(purchaseCostRow.rows, function (currentPurchaseCostRow) {
                        currentPurchaseCostRow.quantity = orderRow.quantity;
                        purchaseCostRow.effectivePurchasePrice = calculateEffectivePurchasePrice(purchaseCostRow.originalPurchasePrice, purchaseCostRow.discountPercent);
                        purchaseCostRow.purchaseCost = getTotalRowSum(currentPurchaseCostRow);

                    });
                }
            });

            if (rowsGrid.invalidate) {
                rowsGrid.invalidate();
            }
            if (variantPricesGrid.invalidate) {
                variantPricesGrid.invalidate();
            }
        }
    }
}
